module.exports = __webpack_public_path__ + "assets/img/putin-440.31d55f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/putin-440.jpg
// module id = HV7/
// module chunks = 0